import styled from "@emotion/styled";

export default styled("div")`
  font-size: 0.8rem;
  color: #999;
  font-weight: normal;
`;
